import { NoResult } from 'ui/illustrations';
import { AlternativeState } from './AlternativeStateTemplate';

export const NoSearchResultsCopy = {
  title: 'No matching results',
  subtitle: 'Try searching by different keywords.',
};

export const NoSearchResultsState = () => (
  <AlternativeState
    Illustration={NoResult}
    title={NoSearchResultsCopy.title}
    subtitle={NoSearchResultsCopy.subtitle}
  />
);
